<template>
<div>
    <div 
        class="row results-course-card"
        :class="{'results-course-card--detail': isDetail}"
    >
        <div class="col-12 col-lg-3 results-course-card__image clickable no-padding">
            <span 
                v-if="course.has_payment_enabled"
                data-toggle="tooltip"
                data-placement="top"
                title="Accetta i coupon sconto"
            >
                <img
                    src="/images/accept-payments-badge.svg"
                    alt="badge"
                    class="accept-payment-badge"
                />
            </span>
            <a :href="hrefCourse(course)">
                <img 
                    v-if="course.course_thumb_image" 
                    :src="course.course_thumb_image"
                />
                <img 
                    v-else
                    :src="course.course_image"
                />
            </a>
        </div>
        <div class="col-lg-9 col-12 results-course-card__info-container">
            <p class="results-course-card__body__address">
                <i class="fa fa-map-marker-alt"></i> {{course.address}}
            </p>
            <p class="m-0">
                <a 
                    :href="hrefCourse(course)"
                    class="results-course-card__body__name text-capitalize"
                >
                    <b>{{course.seo_name | capitalize}}</b>
                </a>
            </p>
            <p 
                class="m-0" 
                v-if="course.company.url"
            >
                <a 
                    :href="course.company.url" 
                    class="m-0 font-18"
                >{{course.company.name | capitalize}}</a>
            </p>
            <div class="results-course-card__down-container">
                <div class="results-course-card__down-container__left">
                    <div class="results-course-card__down-container__sport-tag-container">
                        <span class="results-course-card__down-container__sport-tag-container__tag">
                            {{course.sport ? course.sport.name : ''}}
                        </span>
                    </div>
                    <div class="results-course-card__body__lessons p-r-10">
                        <span 
                            v-for="day in days"
                            class="results-course-card__body__lessons__day"
                            :class="{'results-course-card__body__lessons__day--has-lesson': day.lesson}"
                        >
                            {{day.name}}
                        </span>
                    </div>
                    <div class="results-course-card__body__short-age-range m-l-10">
                        <p>
                            <i class="fas fa-user"></i> {{course.start_age}} - {{course.end_age}} anni
                        </p>
                    </div>
                </div>
                <div class="results-course-card__actions-container">
                    <div class="results-course-card__actions-container__actions">
                        <a 
                            class="btn btn-primary clickable"
                            :href="hrefCourse(course)"
                        >Scopri</a>
                    </div>
                </div>
            </div>
            <div>
                <p 
                    v-if="course.distance_from_my_position"
                    class="results-course-card__body__age-range"
                >
                    <i class="fa fa-map-marker-alt"></i> a {{course.distance_from_my_position | round }} km da te
                </p>
            </div>
        </div>
    </div>
    <div 
        v-if="course.is_promoted"
        class="row results-course-card"
        :class="{'results-course-card--detail': isDetail}"
    >
        <div class="col-12 col-lg-3 results-course-card__image clickable no-padding">
            <span
                v-if="course.company.accept_payments"
                data-toggle="tooltip"
                data-placement="top"
                title="Accetta i coupon sconto"
            >
                <img 
                    src="/images/invito_allo_sport_verde.svg"
                    alt="badge"
                    class="course-invite-logo"
                />
            </span>
            <a :href="hrefPromotedCourse(course)">
                <img 
                    v-if="course.course_thumb_image"
                    v-lazy="course.course_thumb_image"
                />
                <img 
                    v-else
                    v-lazy="course.course_image"
                />
            </a>
        </div>
        <div class="col-12 col-lg-9 results-course-card__info-container">
            <p class="results-course-card__body__address">
                <i class="fa fa-map-marker-alt"></i> {{course.address}}
            </p>
            <p class="m-0">
                <a 
                    :href="hrefPromotedCourse(course)"
                    class="results-course-card__body__name text-capitalize"
                >
                    <b>{{course.seo_promo_name | capitalize}}</b>
                </a>
            </p>
            <p 
                class="m-0"
                v-if="course.company.url"
            >
                <a 
                    :href="course.company.url"
                    class="m-0 font-18"
                >{{course.company.name | capitalize}}</a>
            </p>
            <div class="results-course-card__down-container">
                <div class="results-course-card__down-container__left">
                    <div class="results-course-card__down-container__sport-tag-container">
                        <span class="results-course-card__down-container__sport-tag-container__tag">
                            {{course.sport.name}}
                        </span>
                    </div>
                    <div class="results-course-card__body__lessons p-r-10">
                        <span
                            v-for="day in days"
                            class="results-course-card__body__lessons__day"
                            :class="{'results-course-card__body__lessons__day--has-lesson': day.lesson}"
                        >
                            {{day.name}}
                        </span>
                    </div>
                    <div class="results-course-card__body__short-age-range m-l-10">
                        <p>
                            <i class="fas fa-user"></i> {{course.start_age}} - {{course.end_age}} anni
                        </p>
                    </div>
                </div>
                <div class="results-course-card__actions-container">
                    <div class="results-course-card__actions-container__actions">
                        <a 
                            class="btn btn-primary clickable" 
                            :href="hrefPromotedCourse(course)"
                        >Scopri</a>
                    </div>
                </div>
            </div>
            <div>
                <p 
                    v-if="course.distance_from_my_position"
                    class="results-course-card__body__age-range"
                >
                    <i class="fa fa-map-marker-alt"></i> a {{course.distance_from_my_position | round }} km da te
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'ResultsCourseCard',
    props: {
        course: {
            type: Object,
            required: true
        },
        isDetail: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            days: [
                {name: 'L', long: 'Lunedì', dow: 0, lesson: false},
                {name: 'M', long: 'Martedì', dow: 1, lesson: false},
                {name: 'M', long: 'Mercoledì', dow: 2, lesson: false},
                {name: 'G', long: 'Giovedì', dow: 3, lesson: false},
                {name: 'V', long: 'Venerdì', dow: 4, lesson: false},
                {name: 'S', long: 'Sabato', dow: 5, lesson: false},
                {name: 'D', long: 'Domenica', dow: 6, lesson: false}
            ],
            tempTags: [
                {icon: 'fa-map-marker-alt', text: 'A 10 minuti da te', color: 'orangogo'},
                {icon: 'fa-tag', text: '-30% sconto', color: 'primary'}
            ],
            reviews_avg_score: 0
        }
    },
    mounted() {
        this.aggiornaDays();
        this.reviews_avg_score = this.course.reviews_avg_score;
    },
    watch: {
        'course.days'() {
            this.aggiornaDays();
        }
    },
    methods: {
        aggiornaDays() {
            let self = this;

            this.days.forEach(function (day) {
                let isPresent = false;

                self.course.days.forEach(function (course_day) {
                    if (course_day.dow === day.dow) {
                        isPresent = true;
                    }
                });

                day.lesson = isPresent;
            });
        },
        hrefCourse(course) {
            return `/corsi/${course.slug}`;
        },
        hrefPromotedCourse(course) {
            return `/corsi/${course.slug}/avvicinamento`;
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/ResultsCourseCard.vue